const InfoBeforeConfirm = ({ length }) => {
  let seconds = length * 2;
  let minutes = Math.floor(seconds / 60);
  let hours = Math.floor(minutes / 60);
  seconds = seconds % 60;
  return (
    <div>
      {" "}
      <p>The are {length} Invoices to confirm</p>
      <p>
        the confirmation process will take {hours} h : {minutes} min : {seconds}{" "}
        sec <br /> make sure you login time will not run out in this time
      </p>
      <p>do you want to confirm?</p>{" "}
    </div>
  );
};

export default InfoBeforeConfirm;
